import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { FaArrowLeft, FaSpinner } from "react-icons/fa";
import { Link } from "react-scroll";
// Components
import GuardsDetailsContainer from "../CardsDetails/GuardsDetailContainer";
import NannyDetailContainer from "../CardsDetails/NannyDetailContainer";
import Card from "../Elements/Card";
import { motion } from "framer-motion";

// Assets
import Guard from "../../assets/icons/guard.png";
import Map from "../../assets/icons/map.png";
import Phone from "../../assets/icons/phone.png";
import Nurse from "../../assets/icons/nurse.png";
import Driver from "../../assets/icons/driver.png";
import Nanny from "../../assets/icons/nanny.png";
import AddCook from "../../assets/icons/cook.png";
import Cleaner from "../../assets/icons/cleaner.png";
import HusbandWife from "../../assets/img/Services/hw-service.jpg";
import HusbandWifeDriver from "../../assets/img/Services/hw-driver.jpg";
import HusbandWifeGuard from "../../assets/img/Services/hw-guards.jpg";
import FemaleChef from "../../assets/img/Services/femChef.jpg";
import Chef from "../../assets/img/Services/cheff.jpg";
import CookService from "../../assets/img/Services/cook-service.jpg";
import Allrounder from "../../assets/img/Services/allrmaid.jpg";
import BabySitter from "../../assets/img/Services/babysit.jpg";
import CareTaker from "../../assets/img/Services/caretaker.jpg";
import DriverUnc from "../../assets/img/Services/driver.jpg";
import Helper from "../../assets/img/Services/helper.jpg";
import Housemaid from "../../assets/img/Services/housemaid.jpg";
import Nigerian from "../../assets/img/Services/niger.jpg";
import Phillipine from "../../assets/img/Services/philip.jpg";
import Srilankan from "../../assets/img/Services/srilan.jpg";
import Nurses from "../../assets/img/Services/nurses.jpg";
import OfficeBoy from "../../assets/img/Services/officeboy.jpg";
import Receptionist from "../../assets/img/Services/receptionist.jpg";
import Teacher from "../../assets/img/Services/teacher.jpg";
import SecGuard from "../../assets/img/Services/secGuard.jpg";
import Secretary from "../../assets/img/Services/secretary.jpg";
import CleanerDetailContainer from "../CardsDetails/CleanerDetailContainer";
import NurseDetailContainer from "../CardsDetails/NurseDetailContainer";
import CookDetailContainer from "../CardsDetails/CookDetailContainer";
import DriverDetailContainer from "../CardsDetails/DriverDetailContainer";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Helmet } from "react-helmet";

const serviceJson = [
  {
    title: "Wife Husband",
    description: "Professional domestic couples for household support.",
    image: HusbandWife,
  },
  {
    title: "Driver Wife Husband",
    description:
      "Reliable driving & domestic support by couples. Ensures safe travel & home help.",
    image: HusbandWifeDriver,
  },
  {
    title: "Khansama",
    description: "Experienced cooks skilled in Pakistani & continental dishes.",
    image: CookService,
  },
  {
    title: "Guard Husband Wife",
    description:
      "Couples trained in home security & safety tasks. Suitable for villas & offices.",
    image: HusbandWifeGuard,
  },
  {
    title: "House Maid",
    description:
      "Trained maids for cleaning, laundry, & general upkeep. Available for all cities.",
    image: Housemaid,
  },
  {
    title: "Nanny / Babby Sitter",
    description:
      "Caring & responsible babysitters for infants & toddlers.Verified staff.",
    image: BabySitter,
  },
  {
    title: "All Rounder Maid",
    description:
      "Versatile maids for cooking, cleaning, & child care. Ideal for busy households.",
    image: Allrounder,
  },
  {
    title: "Female Chef",
    description:
      "Expert female chefs for healthy & hygienic home-cooked meals. Customizable menus.",
    image: FemaleChef,
  },
  {
    title: "Care Taker",
    description:
      "Compassionate caretakers for elderly or disabled individuals. 24/7 available.",
    image: CareTaker,
  },
  {
    title: "Nurse",
    description:
      "Qualified nurses for home patient care, wound dressing, & medical monitoring.",
    image: Nurses,
  },
  {
    title: "Secretary",
    description:
      "Professional secretaries for admin & scheduling support. Skilled in office tools.",
    image: Secretary,
  },
  {
    title: "Driver",
    description:
      "Experienced drivers with valid licenses & city routes knowledge.",
    image: DriverUnc,
  },
  {
    title: "Guard",
    description:
      "Trained guards for residential & commercial security. Day & night shifts available.",
    image: SecGuard,
  },
  {
    title: "Chef",
    description:
      "Home chefs specialized in desi & intl cuisines. Meal prep & diet plans.",
    image: Chef,
  },
  {
    title: "Helper",
    description:
      "General helpers for household or office work. Flexible timings & trustworthy.",
    image: Helper,
  },
  {
    title: "Philipino",
    description:
      "Skilled and professional Filipino staff for home care, nanny, & cleaning services.",
    image: Phillipine,
  },
  {
    title: "Nigeria",
    description:
      "Reliable Nigerian domestic staff trained in housekeeping and cooking duties.",
    image: Nigerian,
  },
  {
    title: "Srilankan",
    description:
      "Professional Sri Lankan maids & helpers. Known for discipline & cleanliness.",
    image: Srilankan,
  },
  {
    title: "Education Staff",
    description:
      "Qualified tutors & academic assistants for children of all grades.",
    image: Teacher,
  },
  {
    title: "Office Boy",
    description:
      "Efficient office boys for errands, cleaning, & administrative support.",
    image: OfficeBoy,
  },
  {
    title: "Receptionist",
    description:
      "Smart & presentable receptionists for front desk & client handling.",
    image: Receptionist,
  },
];

export default function Services() {
  const [selectedCard, setSelectedCard] = useState(null);
  const [loading, setLoading] = useState(false);

  const cards = [
    { id: 1, img: AddCook, title: "Cooking" },
    { id: 2, img: Nanny, title: "Nanny" },
    { id: 3, img: Driver, title: "Driver" },
    { id: 4, img: Cleaner, title: "Cleaner" },
    { id: 5, img: Nurse, title: "Nurse" },
    { id: 6, img: Guard, title: "Guards" },
  ];

  const handleCardClick = (id) => {
    setLoading(true);
    setSelectedCard(id);
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Simulate loading time
  };

  const overseasCountries = [
    { name: "Pakistan", code: "pk" },
    { name: "Philippines", code: "ph" },
    { name: "Nigeria", code: "ng" },
    { name: "Sri Lanka", code: "lk" },
    { name: "Dubai, Sharjah (UAE)", code: "ae" },
    { name: "Saudi Arabia", code: "sa" },
  ];

  const cardsId = cards.find((card) => card.id === selectedCard);

  return (
    <motion.div
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
    >
      <Helmet>
        <title>Our Services | Maids Service Pakistan</title>
        <meta
          name="description"
          content="Explore our 24/7 maid services, including one-time, weekly, and monthly cleaning plans across major cities in Pakistan."
        />
      </Helmet>

      <Wrapper id="services">
        <div className="whiteBg" style={{ padding: "60px 0" }}>
          <div className="container">
            <HeaderInfo style={{}}>
              <h1 style={{ marginLeft: "3%" }} className="font40 extraBold">
                Our Awesome Services
              </h1>
              <p
                className="font20"
                style={{ maxWidth: "900px", marginLeft: "3%" }}
              >
                Enjoy top-quality home care with our reliable and professional
                maids. Our services ensure your home is always clean and
                well-maintained in Karachi, Lahore, and Islamabad.
                <br />
              </p>
            </HeaderInfo>
            <ServicesWrapper>
              {selectedCard === null ? (
                <ServiceBoxWrap>
                  <CardsRow>
                    {cards.map((card) => (
                      <Link to="services">
                        <Card
                          key={card.id}
                          img={card.img}
                          title={card.title}
                          onClick={() => handleCardClick(card.id)}
                        />
                      </Link>
                    ))}
                  </CardsRow>
                </ServiceBoxWrap>
              ) : (
                <ServiceBoxWrap>
                  {loading && (
                    <LoaderWrapper>
                      <FaSpinner className="spinner" />
                    </LoaderWrapper>
                  )}
                  {!loading && (
                    <CardAndTabsWrapper>
                      <CardDetails isVisible={selectedCard !== null}>
                        <BackIcon onClick={() => setSelectedCard(null)}>
                          <FaArrowLeft />
                        </BackIcon>
                        {cardsId.id === 1 ? (
                          <CookDetailContainer />
                        ) : cardsId.id === 2 ? (
                          <NannyDetailContainer />
                        ) : cardsId.id === 3 ? (
                          <DriverDetailContainer />
                        ) : cardsId.id === 4 ? (
                          <CleanerDetailContainer />
                        ) : cardsId.id === 5 ? (
                          <NurseDetailContainer />
                        ) : cardsId.id === 6 ? (
                          <GuardsDetailsContainer />
                        ) : null}
                      </CardDetails>
                      <TabsColumn>
                        <TabsContainer>
                          <h2 className="font25 semiBold">OUR SERVICES</h2>
                          {cards.map((card) => (
                            <Link to="services">
                              <Tab
                                key={card.id}
                                onClick={() => handleCardClick(card.id)}
                                active={card.id === selectedCard}
                                hidden={card.id === selectedCard}
                              >
                                {card.title}
                              </Tab>
                            </Link>
                          ))}
                        </TabsContainer>
                        <EmptyContainer>
                          <ImageWrapper>
                            <Image src={Map} />
                          </ImageWrapper>

                          <p style={{ textAlign: "center" }}>
                            Shop: 3, Plot: 41c, Street: 3, Khalid Commercial DHA
                            phase 7 ext, Karachi.
                          </p>
                        </EmptyContainer>
                        <EmptyContainer>
                          <ImageWrapper>
                            <Image src={Phone} />
                          </ImageWrapper>

                          <p style={{ textAlign: "center" }}>
                            Call us at +923350006269
                          </p>
                        </EmptyContainer>
                      </TabsColumn>
                    </CardAndTabsWrapper>
                  )}
                </ServiceBoxWrap>
              )}
              <OverseasWrap>
                <h3>Overseas Staff Also Available</h3>
                <FlagList>
                  {overseasCountries.map((country) => (
                    <FlagItem key={country.code}>
                      <LazyLoadImage
                        src={`https://flagcdn.com/24x18/${country.code}.png`}
                        alt={country.name}
                        width={24}
                        height={18}
                        effect="blur"
                        style={{ display: "inline-block" }}
                      />

                      <span>{country.name}</span>
                    </FlagItem>
                  ))}
                </FlagList>
              </OverseasWrap>
            </ServicesWrapper>
            <div
              className="services-section py-5"
              style={{
                backgroundColor: "#2bb3a5",
                padding: 5,
                paddingTop: 30,
                borderRadius: 10,
              }}
            >
              <div className="container">
                <div className="row g-4">
                  {serviceJson.map((item, index) => (
                    <div className="col-md-4 col-sm-6 col-12" key={index}>
                      <div
                        className="p-4 h-100 d-flex flex-column justify-content-between"
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "16px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                          transition: "transform 0.2s",
                          padding: "4%",
                          marginBottom: "6%",
                        }}
                      >
                        <LazyLoadImage
                          src={
                            item.image || "https://via.placeholder.com/400x200"
                          }
                          alt={item.title || "Maid Services"}
                          effect="blur" // or "opacity" if you prefer fade-in
                          placeholderSrc="https://via.placeholder.com/400x200?text=Loading..."
                          className="img-fluid mb-3"
                          style={{
                            borderRadius: "10px",
                            height: "auto",
                            objectFit: "cover",
                            width: "100%",
                            border: "2px solid rgb(9, 241, 214)",
                          }}
                        />

                        <h4
                          className="fw-semibold text-dark mb-2"
                          style={{ marginBottom: 5, marginTop: 5 }}
                        >
                          {item.title}
                        </h4>
                        <p className="text-muted small mb-0">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </motion.div>
  );
}

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const ImageWrapper = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #e0f7fa;
  margin: 0 auto 10px auto;
  flex-direction: column;

  &:hover {
    transform: scale(1.1);
  }
`;

const OverseasWrap = styled.div`
  margin-top: 40px;
  padding-top: 20px;
  border-top: 2px dashed #2fb8a7;
  text-align: center;
  border-bottom: 2px dashed #2fb8a7;

  h3 {
    font-size: 20px;
    font-weight: bold;
    color: #0c6284;
    margin-bottom: 15px;
  }
`;

const FlagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;

const FlagItem = styled.div`
  display: flex;
  align-items: center;
  background: #f1fdfc;
  padding: 8px 12px;
  border-radius: 30px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);

  img {
    width: 24px;
    height: 18px;
    margin-right: 8px;
    border-radius: 4px;
  }

  span {
    font-size: 14px;
    color: #333;
  }
`;

const Image = styled.img`
  width: 100px;
  height: auto;
`;

const Wrapper = styled.section`
  width: 100%;
  margin-top: 5%;
`;

const ServicesWrapper = styled.div`
  padding: 20px;
`;

const ServiceBoxWrap = styled.div`
  background-color: #e2fef5;
  padding: 30px;
  border-radius: 10px;
  position: relative;
  /* Set a fixed size or use a min-height to ensure consistent size */
  min-height: 400px; /* Adjust as needed */
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const LoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .spinner {
    font-size: 24px;
    color: #2fb8a7;
    animation: ${spin} 1s linear infinite;
  }
`;

const BackIcon = styled.div`
  cursor: pointer;
  font-size: 24px;
  color: #2fb8a7;

  &:hover {
    color: #68dbab;
  }
`;

const CardAndTabsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const TabsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    order: 2; /* Ensure tabs appear below card details on mobile */
  }
`;

const TabsContainer = styled.div`
  padding: 10px;
  border-radius: 20px;
  text-align: center;

  @media (max-width: 768px) {
    order: 2; /* Ensure tabs appear below card details on mobile */
    padding: 40px;
  }
`;

const EmptyContainer = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;

  @media (max-width: 768px) {
    order: 2;
  }
`;

const Tab = styled.div`
  max-width: 600px;
  width: 100%;
  padding: 10px 50px;
  cursor: pointer;
  text-align: center;
  font-weight: 600;
  background-color: ${({ active }) =>
    active
      ? "linear-gradient(119.49deg, #68dbab 3.02%, #2fb8a7 111.32%)"
      : "#ffffff"};
  border-radius: 30px;
  color: #0c6284;
  flex-shrink: 0;
  margin-bottom: 3%;

  &:hover {
    background: linear-gradient(119.49deg, #68dbab 3.02%, #2fb8a7 111.32%);
    color: #ffffff;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    display: ${({ hidden }) => (hidden ? "none" : "block")};
  }
`;

const CardDetails = styled.div`
  padding: 20px;
  width: 75%;
  background-color: white;
  border-radius: 20px;

  @media (max-width: 768px) {
    width: 100%;
    order: 1; /* Ensure card details appear above tabs on mobile */
  }
`;

const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
